import Error from "@/prototype/utils/Error.js";
import ConfirmationArea from "@/prototype/ui/ConfirmationArea.js";

import global from "@/prototype/global.js";

import PQueue from "p-queue/dist/index.js";

const log = global.log.getLogger("f_mtac.MessageIndex");

const MESSAGE_CREATE = 11;

// changeset state
const CHANGESET_PENDING = 21;
const CHANGESET_WAITING = 22;
const CHANGESET_PUSHED = 23;

// flags
const FLAG_NONE = 0;
const FLAG_DELETE_ALL = 1;

let changeset_prototype = {
    create: function () {
        this.method = MESSAGE_CREATE;
    }
};
let Changeset = function (local_id) {
    this.method = null;
    this.state = CHANGESET_PENDING;
    this.new_message = null;
    this.rx_time = null;
    this.tx_time = null;
    Object.defineProperty(this, "local_id", {
        set: () => {},
        get: () => local_id
    });
};
Object.assign(Changeset.prototype, changeset_prototype);
let Store = function (context) {
    var flags = FLAG_NONE;
    var stack = Object();
    var room = null;
    var local_segment = {rx_time_min: null, rx_time_max: null};
    Object.defineProperty(this, "room", {
        set: (new_room) => {
            if (new_room === null) {
                room = null;
                return;
            }
            room = new_room;
        },
        get: () => room
    });

    Object.defineProperty(this, "local_segment", {
        set: () => {},
        get: () => local_segment
    });

    this.set_local_segment = (rx_time_min, rx_time_max) => {
        log.warn("this set method is deprecated use local segment directly");
        local_segment.rx_time_min = rx_time_min;
        local_segment.rx_time_max = rx_time_max;
    };

    this.get_local_segment = () => {
        log.warn("this get method is deprecated use local segment directly");
        return local_segment;
    };

    this.init = (new_room) => {
        /*let old_room = room;
        if (String(old_room) === String(new_room)) {
            return Promise.resolve();
        }*/

        stack = Object();
        flags = FLAG_NONE;
        local_segment.rx_time_min = null;
        local_segment.rx_time_max = null;
        room = new_room;

        return context.message_retrieve({}).each((message) => {
            //if (!("rx_time" in message)) {
            this.commit({
                local_id: message.local_id,
                tx_time: message.tx_time,
                new_message: message
            });
            //}
        });
    };

    this.deinit = () => {
        stack = Object();
        flags = FLAG_NONE;
        local_segment.rx_time_min = null;
        local_segment.rx_time_max = null;
        room = null;
        return context.message_retrieve({}).modify((message) => {
            delete message.rx_time;
        });
    };

    this.commit_delete_all = ({rx_time}) => {
        if (rx_time === undefined) {
            for (let local_id in stack) {
                delete stack[local_id];
            }
            flags |= FLAG_DELETE_ALL; // rise the delete all flag
        } else {
            local_segment.rx_time_min = null;
            local_segment.rx_time_max = null;
        }
    };

    this.commit = ({local_id, rx_time, tx_time, new_message, old_message}) => {
        let changeset = null;
        old_message; // not used for now

        if (rx_time !== undefined) {
            if (new_message !== undefined && old_message === undefined) {
                if (local_segment.rx_time_min === null) {
                    local_segment.rx_time_min = rx_time;
                }
                local_segment.rx_time_max = rx_time;
            }
            log.info(`message_index: commit with rx_time just updating remote local segment ${local_segment.rx_time_min} ${local_segment.rx_time_max}`);
            return changeset;
        }

        if (local_id in stack) {
            changeset = stack[local_id];
            changeset.state = CHANGESET_PENDING;
        } else {
            changeset = new Changeset(local_id);
            stack[local_id] = changeset;
        }

        if (new_message !== undefined && old_message === undefined) {
            changeset.create();
        }

        if (tx_time !== undefined) {
            changeset.tx_time = tx_time;
        } else {
            changeset.tx_time = Date.now();
        }

        switch (changeset.method) {
            case MESSAGE_CREATE:
                changeset.new_message = new_message;
                break;
        }
        return changeset;
    };

    const rx_tx_queue = new PQueue({concurrency: 1});

    const push = async () => {
        if (room === null) {
            return;
        }

        let handle_network_error = async (error) => {
            switch (error.status) {
                case Error.status.conflict:
                    var confirmation = await ConfirmationArea.interact({
                        title: global.internationalization.text("collaboration.Conflict"),
                        tip1: global.internationalization.text("collaboration.Local-crisis-cannot-be-synchronized"),
                        tip2: global.internationalization.text("collaboration.Accept-server-crisis"),
                        accept: true,
                        backdrop: "static"
                    });
                    if (!confirmation) {
                        return global.storage.unshare({});
                    }
                    // on récupere la version reseau => vider la stack et la log tab
                    flags &= ~FLAG_DELETE_ALL;
                    for (let local_id in stack) {
                        delete stack[local_id];
                    }
                    await context.message_delete_all({rx_time: 0});
                    return pull();
                case Error.status.exist:
                case Error.status.netdown:
                case Error.status.hostdown:
                    return;
            }
            log.error("failed to handle message error, will try again next time", error);
            return;
        };

        if (flags & FLAG_DELETE_ALL) {
            if (local_segment.rx_time_min !== null && local_segment.rx_time_max !== null) {
                try {
                    await global.server.mtac_message_delete({
                        space: room.space,
                        time_min: local_segment.rx_time_min,
                        time_max: local_segment.rx_time_max
                    });
                } catch (error) {
                    return handle_network_error(error);
                }
                local_segment.rx_time_min = null;
                local_segment.rx_time_max = null;
            }
            flags &= ~FLAG_DELETE_ALL;
        }

        var changesets = [],
            updated = [];
        for (let local_id in stack) {
            let changeset = stack[local_id];
            if (changeset.state !== CHANGESET_PENDING) {
                continue;
            }
            changeset.state = CHANGESET_WAITING;
            changesets.push(changeset);
        }

        for (let changeset of changesets) {
            let response;
            let method_data = {
                space: room.space,
                tx_delta: Date.now() * 1000 - changeset.new_message.tx_time
            };
            switch (changeset.method) {
                case MESSAGE_CREATE:
                    Object.assign(method_data, {
                        text: changeset.new_message.text,
                        media_id: changeset.new_message.media_id,
                        type: changeset.new_message.type,
                        sender_tx_time: changeset.new_message.sender_tx_time
                    });
                    try {
                        response = await global.server.mtac_message_create(method_data);
                    } catch (error) {
                        //if error = 409  = message already exists in server => delete the changeset in stack to not resend message creation
                        if (error.status === Error.status.exist){
                            delete stack[changeset.local_id];
                        } else {
                            for (let changeset of changesets) {
                                if (changeset.state === CHANGESET_WAITING) {
                                    changeset.state = CHANGESET_PENDING;
                                }
                            }
                        }
                        return handle_network_error(error);
                    }
                    break;
            }
            changeset.rx_time = response.data.rx_time;
            changeset.tx_time = response.data.tx_time;
            changeset.state = CHANGESET_PUSHED;
            delete stack[changeset.local_id];

            switch (changeset.method) {
                case MESSAGE_CREATE:
                    updated.push(context.message_update(changeset));
                    if (local_segment.rx_time_min === null) {
                        local_segment.rx_time_min = changeset.rx_time;
                    }
                    local_segment.rx_time_max = changeset.rx_time;
                    break;
            }
        }

        await Promise.all(updated);
    };
    this.push = () => rx_tx_queue.add(() => push());

    const pull = async () => {
        if (room === null) {
            return;
        }
        try {
            var messages = await global.server.mtac_message_retrieve({
                space: room.space
            });
        } catch (error) {
            switch (error.status) {
                case Error.status.noent:
                    log.error(`unable to list messages, room space ${room.space} doesn't exist`);
                    return;
                case Error.status.netdown:
                case Error.status.hostdown:
                    return;
                default:
                    log.error("failed to handle message update error, will try again next time", error);
                    return;
            }
        }
        if (messages.length === 0) {
            if (local_segment.rx_time_min != null) {
                // messages deleted during disconnection
                local_segment.rx_time_min = null;
                local_segment.rx_time_max = null;
                return context.message_delete_all({rx_time: 0});
            }
            return;
        }
        let updates = [];
        let remote_segment = {
            rx_time_min: messages[0].rx_time,
            rx_time_max: messages[messages.length - 1].rx_time
        };

        if (local_segment.rx_time_min !== null && local_segment.rx_time_min !== remote_segment.rx_time_min) {
            for (let local_id in stack) {
                delete stack[local_id];
            }
            await context.message_delete_all({rx_time: remote_segment.rx_time_min});
        }
        local_segment.rx_time_min = remote_segment.rx_time_min;
        local_segment.rx_time_max = remote_segment.rx_time_max;
        messages.forEach((remote_message) => {
            updates.push(
                context
                    .message_retrieve(remote_message)
                    .first()
                    .then((local_message) => {
                        if (local_message !== undefined) {
                            return;
                        }
                        return context.message_create(remote_message);
                    })
            );
        });
        return Promise.all(updates);
    };
    this.pull = () => rx_tx_queue.add(() => pull());
};
export default Store;
